import { AxiosResponse } from "axios";
import axios, { configHeader } from "./axios";

export interface AppSettings {
  id: number;
  dailyOrderLimit: number;
  dailyDessertLimit: number;
  fridaySpecialActive: boolean;
  fridaySpecialImage: string | null;
  fridaySpecialImageFileId: string | null;
  fridaySpecialDescription: string | null;
  updatedAt?: string;
  updatedById?: number | null;
}

// Module-level cache so menu pages don't round-trip on every render. Cleared
// by patchSettings so subsequent reads see the new limit immediately.
let cached: AppSettings | null = null;
let pending: Promise<AppSettings> | null = null;

export const loadSettingsCached = async (): Promise<AppSettings> => {
  if (cached) return cached;
  if (pending) return pending;
  pending = getSettings()
    .then((s) => { cached = s; return s; })
    .finally(() => { pending = null; });
  return pending;
};

export const patchSettings = async (
  body: { dailyOrderLimit?: number; dailyDessertLimit?: number },
): Promise<AppSettings> => {
  const response: AxiosResponse<AppSettings> = await axios.patch("/settings", body, configHeader());
  cached = response.data;
  return response.data;
};

export const getSettings = async (): Promise<AppSettings> => {
  const response: AxiosResponse<AppSettings> = await axios.get("/settings", configHeader());
  return response.data;
};

export const patchFridaySpecial = async (body: {
  active: boolean;
  description: string | null;
  image: string | null;
  imageFileId: string | null;
}): Promise<AppSettings> => {
  const response: AxiosResponse<AppSettings> = await axios.patch(
    "/settings/friday-special",
    body,
    configHeader(),
  );
  return response.data;
};
